import mitt from 'mitt';

export function createEventBus() {
	const emitter = mitt();
	return {
		$on: emitter.on,
		$once: emitter.once,
		$off: emitter.off,
		$emit: emitter.emit,
	}
}
